import axios, { AxiosRequestConfig } from 'axios';

axios.defaults.timeout = 600000;
// axios.defaults.crossDomain = true;
//意思是携带cookie信息,保持session的一致性
axios.defaults.withCredentials = true;
axios.defaults.headers.post['Content-Type'] =
  'application/x-www-form-urlencoded';

import qs from 'qs';
import router from '../router';
import store from '../store/index';
//import { useStore } from '@/store';
import CryptoJS from 'crypto-js';
import crypto from 'crypto';
import { ElMessage, ElMessageBox } from 'element-plus';
import Area from '@/beans/area';

const tool = {
  WEB_ROOT: 'https://www.sqmjw.com',

  //WEB_ROOT: 'http://localhost:8080',

  WEB_CONTEXT: '/design',

  isShowLoginConfirm: false,

  areaJson: {},

  areaCodeToText: new Map([['all', '请选择']]),

  areaTextToCode: new Map([['请选择', 'all']]),

  //登出接口使用，其他接口必须用post请求！！！
  get: function (url: string, data: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      //const store = useStore();
      axios
        .get(tool.url(url), data)
        .then((result) => {
          if (result.status == 500) {
            ElMessage.error('网络错误,请求不可到达...');
          } else {
            if (result.data.status === 2000 || result.data.status === 5000) {
              resolve(result.data);
            } else if (result.data.status === 3001) {
              if (!store.state.unLoginList.includes(router.getRoutes.name)) {
                // 需要登录的页面才需要，做未登录处理
                if (!tool.isShowLoginConfirm) {
                  tool.isShowLoginConfirm = true;
                  ElMessageBox.confirm('登录已过期，是否跳转到登录页?')
                    .then(() => {
                      router.push({
                        path: '/frontDesk/login',
                      });
                      store.commit('user', {});
                    })
                    .catch(() => {
                      // catch error
                    });
                }
              }
              reject(result.data);
            } else {
              reject(result.data);
            }
          }
        })
        .catch((err) => {
          console.error(err);
          if (err.response.status == 500) {
            ElMessage.error('网络错误,请求不可到达...');
          }
        });
    });
  },

  downloadExcel: function (url: string, data: any): Promise<any> {
    // console.log('我是dom0000');
    return new Promise<any>((resolve, reject) => {
      //const store = useStore();
      let date = new Date();
      let fileName =  date.getFullYear() +"-"+ (date.getMonth() + 1)  +"-"+ date.getDate() +"-"+ date.getHours()  +"-"+ date.getMinutes() +"-"+ date.getSeconds() +".xlsx";
      let reqConfig: AxiosRequestConfig = {
        responseType: "blob"
      };
      axios
        .post(tool.url(url), tool.str(data), reqConfig)
        .then((result) => {
          if (result && result.data != null) {
            let data = result.data;

            if (!data) {
              let resultObj = {
                status: 5000,
                msg: "下载失败!"
              };
              reject(resultObj);
              return
            }
            var blob = new Blob([data], { type: 'application/vnd.ms-excel' })
            var url = window.URL.createObjectURL(blob);
            var aLink = document.createElement("a");
            aLink.style.display = "none";
            aLink.href = url;
            aLink.setAttribute("download", fileName);
            document.body.appendChild(aLink);
            aLink.click();
            document.body.removeChild(aLink); //下载完成移除元素
            window.URL.revokeObjectURL(url); //释放掉blob对象
            let resultObj = {
              status: 2000,
              msg: "下载成功!"
            };
            reject(resultObj);
          }
        })
        .catch((err: any) => {
          console.error(err);
          if (err.response.status == 500) {
            ElMessage.error('网络错误,请求不可到达...');
          }
          const obj = {
            hook: 'ajax catch',
            errStr: typeof err === 'object' && err.message,
            ratio: window.devicePixelRatio,
            height: window.innerHeight,
            width: window.innerWidth,
            username: localStorage.getItem('username'),
            mobile: localStorage.getItem('mobile'),
            //net: window.navigator.connection ? window.navigator.connection.effectiveType : "", //todo:ygw
            hash: window.location.hash.split('#')[1],
            browser: tool.myBrowser(),
            time: new Date().toLocaleString(),
          };
          const arrStr = sessionStorage.getItem('errorArr') || '[]';
          let arr = [];
          try {
            arr = JSON.parse(arrStr);
            arr = arr.concat ? arr : [];
          } catch (e) {
            arr = [];
          }
          if (!arr.includes(obj.errStr)) {
            const objStr = JSON.stringify(obj);
            const img = document.createElement('img');
            img.src = 'http://120.79.206.175:3000/collect?question=' + objStr;
            document.body.append(img);
            document.body.removeChild(img);
            arr.push(obj.errStr);
            sessionStorage.setItem('errorArr', JSON.stringify(arr));
          }
        });
    });
  },

  /**
   *
   * @param url    链接地址
   * @param data    传递的参数
   * @returns {Promise<any>}
   */
  post: function (url: string, data: any): Promise<any> {
    // console.log('我是dom0000');
    return new Promise<any>((resolve, reject) => {
      //const store = useStore();
      axios
        .post(tool.url(url), tool.str(data))
        .then((result) => {
          if (result.status == 500) {
            ElMessage.error('网络错误,请求不可到达...');
          } else {
            if((result.data.status==null || result.data.status==undefined) && (result.data.msg !=null && result.data.msg != undefined)){
              ElMessage.error(result.data.msg);
              reject(result.data);
            }
            else if (result.data.status === 2000 || result.data.status === 5000) {
              resolve(result.data);
            } else if (result.data.status === 3001) {
              if (!store.state.unLoginList.includes(router.getRoutes.name)) {
                // 需要登录的页面才需要，做未登录处理
                if (!tool.isShowLoginConfirm) {
                  tool.isShowLoginConfirm = true;
                  ElMessageBox.confirm('登录已过期，是否跳转到登录页?')
                    .then(() => {
                      router.push({
                        path: '/frontDesk/login',
                      });
                      store.commit('loginMember', {});
                    })
                    .catch(() => {
                      // catch error
                    });
                }
              }

              //store.commit('loginPop', true)
            } else {
              if (result && result.data) {
                if (
                  typeof result.data === 'string' &&
                  result.data.includes('Access-Control-Allow-Origin')
                ) {
                  // 后端重定向问题，后端接口问题，导致的问题。。
                  if (
                    !store.state.unLoginList.includes(router.getRoutes.name)
                  ) {
                    // 需要登录的页面才需要，做未登录处理
                    router.push({
                      path: '/',
                    });
                    store.commit('user', {});
                    console.log('请登录！');
                  }
                } else {
                  reject(result.data);
                }
              } else {
                console.log('请登录status：200'); //解决后端重定向问题。
              }
            }
          }
        })
        .catch((err: any) => {
          console.error(err);
          if (err.response.status == 500) {
            ElMessage.error('网络错误,请求不可到达...');
          }
          const obj = {
            hook: 'ajax catch',
            errStr: typeof err === 'object' && err.message,
            ratio: window.devicePixelRatio,
            height: window.innerHeight,
            width: window.innerWidth,
            username: localStorage.getItem('username'),
            mobile: localStorage.getItem('mobile'),
            //net: window.navigator.connection ? window.navigator.connection.effectiveType : "", //todo:ygw
            hash: window.location.hash.split('#')[1],
            browser: tool.myBrowser(),
            time: new Date().toLocaleString(),
          };
          const arrStr = sessionStorage.getItem('errorArr') || '[]';
          let arr = [];
          try {
            arr = JSON.parse(arrStr);
            arr = arr.concat ? arr : [];
          } catch (e) {
            arr = [];
          }
          if (!arr.includes(obj.errStr)) {
            const objStr = JSON.stringify(obj);
            const img = document.createElement('img');
            img.src = 'http://120.79.206.175:3000/collect?question=' + objStr;
            document.body.append(img);
            document.body.removeChild(img);
            arr.push(obj.errStr);
            sessionStorage.setItem('errorArr', JSON.stringify(arr));
          }
        });
    });
  },
  /**
   *
   * @param url    链接地址
   * @param data    传递的参数
   * @returns {Promise<any>}
   */
  postJson: function (url: string, data: any): Promise<any> {
    // console.log('我是dom0000');
    return new Promise<any>((resolve, reject) => {
      //const store = useStore();
      let reqConfig = {
        headers: {
          'Content-Type': 'application/json',
        },
      };
      axios
        .post(tool.url(url), JSON.stringify(data), reqConfig)
        .then((result) => {
          if (result.status == 500) {
            ElMessage.error('网络错误,请求不可到达...');
          } else {
            if (result.data.status === 2000 || result.data.status === 5000) {
              resolve(result.data);
            } else if (result.data.status === 3001) {
              if (!store.state.unLoginList.includes(router.getRoutes.name)) {
                // 需要登录的页面才需要，做未登录处理
                if (!tool.isShowLoginConfirm) {
                  tool.isShowLoginConfirm = true;
                  ElMessageBox.confirm('登录已过期，是否跳转到登录页?')
                    .then(() => {
                      router.push({
                        path: '/frontDesk/login',
                      });
                      store.commit('loginMember', {});
                    })
                    .catch(() => {
                      // catch error
                    });
                }
              }

              //store.commit('loginPop', true)
            } else {
              if (result && result.data) {
                if (
                  typeof result.data === 'string' &&
                  result.data.includes('Access-Control-Allow-Origin')
                ) {
                  // 后端重定向问题，后端接口问题，导致的问题。。
                  if (
                    !store.state.unLoginList.includes(router.getRoutes.name)
                  ) {
                    // 需要登录的页面才需要，做未登录处理
                    router.push({
                      path: '/',
                    });
                    store.commit('user', {});
                    console.log('请登录！');
                  }
                } else {
                  reject(result.data);
                }
              } else {
                console.log('请登录status：200'); //解决后端重定向问题。
              }
            }
          }
        })
        .catch((err: any) => {
          console.error(err);
          if (err.response.status == 500) {
            ElMessage.error('网络错误,请求不可到达...');
          }
          const obj = {
            hook: 'ajax catch',
            errStr: typeof err === 'object' && err.message,
            ratio: window.devicePixelRatio,
            height: window.innerHeight,
            width: window.innerWidth,
            username: localStorage.getItem('username'),
            mobile: localStorage.getItem('mobile'),
            //net: window.navigator.connection ? window.navigator.connection.effectiveType : "", //todo:ygw
            hash: window.location.hash.split('#')[1],
            browser: tool.myBrowser(),
            time: new Date().toLocaleString(),
          };
          const arrStr = sessionStorage.getItem('errorArr') || '[]';
          let arr = [];
          try {
            arr = JSON.parse(arrStr);
            arr = arr.concat ? arr : [];
          } catch (e) {
            arr = [];
          }
          if (!arr.includes(obj.errStr)) {
            const objStr = JSON.stringify(obj);
            const img = document.createElement('img');
            img.src = 'http://120.79.206.175:3000/collect?question=' + objStr;
            document.body.append(img);
            document.body.removeChild(img);
            arr.push(obj.errStr);
            sessionStorage.setItem('errorArr', JSON.stringify(arr));
          }
        });
    });
  },
  upLoadImg: function (obj: any) {
    const oReq = new XMLHttpRequest();
    oReq.open('POST', tool.url(obj.url), true);
    oReq.onload = function () {
      if (oReq.status == 200) {
        obj.success(JSON.parse(oReq.response));
      } else {
        obj.fail && obj.fail();
      }
    };
    oReq.send(obj.data);
  },
  str: function (obj: string): string {
    if (obj) {
      return qs.stringify(obj);
    }
    return '';
  },
  blur: function () {
    const dom = document.querySelector('.is-in-pagination .el-input__inner');
    dom &&
      dom.addEventListener('change', function () {
        //this.blur() //todo:ygw
      });
  },
  url: function (url: string): string {
    // const dom = document.querySelector('#projectPath');
    // if(dom && dom.value){
    //     return dom.value + url;
    // } //todo:ygw
    return this.WEB_ROOT + this.WEB_CONTEXT + url;
  },
  fixLength: function (value: string, num: number, obj: any, key: string) {
    obj[key] = value.trim().slice(0, num);
  },

  // //获取域名信息
  // getDomain(vue) {
  //     const domain = vue.$store.state.domainName;
  //     return new Promise((resolve, reject) => {
  //         // ... some code
  //         if (domain) {
  //             resolve(domain);
  //         } else {
  //             this.post('/common/getDomainName').then(data => {
  //                 vue.$store.commit('domainName', data.result)
  //                 resolve(data.result);
  //             }).catch(err => {
  //                 reject(err)
  //             })
  //
  //         }
  //     });
  // },
  extend: function (obj: any = {}, obj1: any = {}): any {
    for (const key in obj1) {
      obj[key] = obj1[key];
    }
    return obj;
  },
  // 字符串处理 为null 返回''
  c: function (value: string, newValue: string): string {
    if (value) {
      return value;
    }
    if (newValue) {
      return newValue;
    }
    return ' ';
  },
  isDev:
    location.hostname === 'localhost' ||
    location.hostname === 'dev1.gzdianxian.com'
      ? true
      : false,
  regMobile: function (mobile: string): boolean {
    return /^1\d{10,10}$/.test(mobile);
  },
  fixedMoney: function (money: any): number {
    if (money && typeof money === 'number') {
      return Math.round(money * 100) / 100;
    } else {
      return 0;
    }
  },
  myBrowser: function (): string {
    const userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
    const isOpera = userAgent.indexOf('Opera') > -1;
    if (isOpera) {
      return 'Opera';
    }
    if (userAgent.toLowerCase().indexOf('se 2.x') > -1) {
      return 'sougou';
    }
    //判断是否Opera浏览器
    if (userAgent.indexOf('Firefox') > -1) {
      return 'FF';
    } //判断是否Firefox浏览器
    if (userAgent.indexOf('Chrome') > -1) {
      return 'Chrome';
    }
    if (userAgent.indexOf('Safari') > -1) {
      return 'Safari';
    } //判断是否Safari浏览器
    if (
      userAgent.indexOf('compatible') > -1 &&
      userAgent.indexOf('MSIE') > -1 &&
      !isOpera
    ) {
      return 'IE';
    } //判断是否IE浏览器
    return '';
  },

  aesEncrypt: function (aesKey: string, source: string): string {
    var key = CryptoJS.enc.Utf8.parse(aesKey);
    var srcs = CryptoJS.enc.Utf8.parse(source);
    var encrypted = CryptoJS.AES.encrypt(srcs, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
    });
    return encrypted.toString();
  },

  md5Encrypt: function (source: string): string {
    var md5 = crypto.createHash('md5');
    //update("中文", "utf8")
    md5.update(source);
    return md5.digest('hex');
  },

  getChinaAreaData(callback: (data: any) => void) {
    //读取文件内容，并转化为Json对象
    let chinaAreaDataJson = require('@/assets/china-area-data.json');
    //获取Json里key为data的数据
    callback(tool.getAreaChildren(chinaAreaDataJson, '86'));
  },

  getAreaChildren(areaDataJson: any, parentCode: string): Area[] {
    const parentObject = areaDataJson[parentCode];
    let parentArray: Area[] = [];
    for (const prop in parentObject) {
      var childArea: Area = {
        value: prop, // 省份code值
        label: parentObject[prop], // 省份汉字
        children: tool.getAreaChildren(areaDataJson, prop),
      };
      tool.areaCodeToText.set(prop, parentObject[prop]);
      tool.areaTextToCode.set(parentObject[prop], prop);
      parentArray.push(childArea);
    }
    return parentArray;
  },

  isNull: function (str: string): boolean {
    if (str == null || str.trim().length <= 0) {
      return true;
    }
    return false;
  },

  isNotNull: function (str: string): boolean {
    if (str == null || str.trim().length <= 0) {
      return false;
    }
    return true;
  },

  getCookieValue: function (cookieName: string): string {
    let result = document.cookie.match(
      "(^|[^;]+)\\s*" + cookieName + "\\s*=\\s*([^;]+)"
    );
    return result ? result.pop() as string : "";
  }
};

export default tool;
